import styled from "styled-components";
import media from "styled-media-query";

export const LayoutWrapper = styled.section`
  display: flex;
  background: var(--background);

  ${media.lessThan("large")`
    flex-direction: column;
  `}
`;

export const LayoutMain = styled.main`
  padding: 0 0 0 20rem;
  transition: background, color 0.5s;
  width: 100%;
  position: absolute;
  height: 100vh;
  overflow-y: scroll;
  
  body#grid & {
    grid-template-areas:
      "posts"
      "pagination";
  }
  ${media.lessThan("large")`
    height: 100vh;
    padding: 4.125rem 0 3rem 0;
  `}
`;
